import { render, staticRenderFns } from "./RuleTable.vue?vue&type=template&id=5b0f08cf"
import script from "./RuleTable.vue?vue&type=script&lang=js"
export * from "./RuleTable.vue?vue&type=script&lang=js"
import style0 from "./RuleTable.vue?vue&type=style&index=0&id=5b0f08cf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports